import { render, staticRenderFns } from "./ProductDetails.vue?vue&type=template&id=71bc62ca&scoped=true&"
import script from "./ProductDetails.vue?vue&type=script&lang=js&"
export * from "./ProductDetails.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetails.vue?vue&type=style&index=0&id=71bc62ca&scoped=true&lang=css&"
import style1 from "./ProductDetails.vue?vue&type=style&index=1&id=71bc62ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bc62ca",
  null
  
)

export default component.exports